<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
       <div class="search">
          <div>
            <el-button type="primary" @click="clickBack">返回</el-button>
            <el-button type="primary" @click="clickQuery">刷新</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="weekId" label="第几周第几天" sortable>
            <template slot-scope="props">
              第{{props.row.weekId}}周的第{{props.row.dayId}}天
            </template>
          </el-table-column>
          <el-table-column prop="courseName" label="课程名称" sortable></el-table-column>
          <el-table-column prop="" label="课程列表封面" width="120">
            <template v-slot="scope">
              <img :src="scope.row.courseIcon" min-width="48" height="48" />
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
          <el-table-column prop="Operation" label="操作" width="200">
            <template slot-scope="scope">
              <el-link v-if="scope.row.courseName == ''" :underline="false" type="primary" class="mr12" @click="clickBind(scope.row)">绑定课程</el-link>
              <el-link v-if="scope.row.courseName !== ''" :underline="false" type="danger" class="mr12" @click="clickUnbind(scope.row)">解绑课程</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- Right End -->
    </div>

    <!-- 绑定课程 -->
    <el-dialog title="绑定课程" :visible.sync="dialogBind" @open="handleDialogBindOpen" width="90%" class="newAdd" :close-on-click-modal="false">
      <WebTwoTrainPlanDatabaseSubBind ref="SubVuesecond" v-on:triggerFunc="closeDialogBind"></WebTwoTrainPlanDatabaseSubBind>
    </el-dialog>
    <!-- 绑定课程 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import WebTwoTrainPlanDatabaseSubBind from '@/componentsSubVue/WebTwoTrainPlanDatabaseSubBind.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    WebTwoTrainPlanDatabaseSubBind
  },
  data () {
    return {
      activeName: 'first',
      trainPlanId: '0',
      trainPlanName: '',
      // 列表
      dataList: [],
      // 绑定课程
      dialogBind: false,
      dialogBindRow: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.trainPlanId = row.id
      this.trainPlanName = "【"+row.trainPlanName+"】的每周训练日程"
      this.TrainPlanDatabaseSubList()
    },
    BackToFirst (val) {
      this.dialogBind = false
      this.TrainPlanDatabaseSubList()
    },
    closeDialogBind(){
      this.dialogBind = false
      this.TrainPlanDatabaseSubList()
    },
    clickQuery () {
      this.TrainPlanDatabaseSubList()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickBind(row){
      this.dialogBind = true
      this.dialogBindRow = row
    },
    handleDialogBindOpen(){
      this.$nextTick(() => {
        this.$refs.SubVuesecond.LoadData(this.dialogBindRow);
      });
    },
    clickUnbind(row){
      this.TrainPlanDatabaseSubUpdate(row.id)
    },
    TrainPlanDatabaseSubList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainPlanId = that.trainPlanId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseSubList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanDatabaseSubUpdate: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.courseId = '0'
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanDatabaseSubUpdate, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.TrainPlanDatabaseSubList()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}
.newAdd /deep/ .el-dialog__body {
  padding: 1px 20px 15px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
